import { useQuery } from "react-query";
import getInvestorOverviewSummary, {
  InvestorOverviewSummaryResponse,
} from "../services/getInvestorOverviewSummary";

function useGetInvestorOverviewSummary(token: string, orgRoleId: number) {
  return useQuery<InvestorOverviewSummaryResponse>({
    queryKey: ["investor-overview-summary"],
    queryFn: () =>
      getInvestorOverviewSummary({
        token,
        orgRoleId,
      }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetInvestorOverviewSummary;
